module.exports = __webpack_public_path__ + "static/media/spinebuzz-2.e431c763.jpg";